import React from 'react'
import { Link } from 'react-router-dom'

const AccessoriesBanner = () => {
  return (
    <>
      {/* content begin */}
      <div className="container-fluild overflow-hidden">
      <section className="nebopan">
        <div
          className="nebopan-banner-section"
          style={{
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/assets/images/maxresdefault-5.png")', 
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <p className="centered-p">Accessoires</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
      <section className="page-banner">
        <div className="container">
          <div className="d-flex flex-column">
            <div className="m-auto">
              <div className="breadcrumbss">
                {/* <div className="breadcrumb-item passed">Essence</div>
                <div className="breadcrumb-item passed">Structure</div>
                <div className="breadcrumb-item active">Accessoires</div>
                <div className="breadcrumb-item">Finalisation</div> */}
                <Link to="/">
                  <div className="breadcrumb-item passed">Essence</div>
                </Link>
                <Link to="/structure">
                  <div className="breadcrumb-item passed">Structure</div>
                </Link>
                <Link to="/accessories">
                  <div className="breadcrumb-item active">Accessoires</div>
                </Link>
                <Link to="/finalization">
                  <div className="breadcrumb-item">Finalisation</div>
                </Link>
              </div>
            </div>
            <h2 className="title">
              Accessoires complémentaires pour finaliser votre projet
            </h2>
          </div>
        </div>
      </section>
    </>

  )
}

export default AccessoriesBanner